import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

const getCellValue = (col, row) => {
  if (typeof col.renderExport === "function") {
    return col.renderExport({ value: row[col.field], row });
  } else if (typeof col.renderCell === "function") {
    return col.renderCell({ value: row[col.field], row });
  } else {
    return row[col.field] ?? "";
  }
};

export const exportToExcel = (columns, rows, fileName = "export.xlsx") => {
  const visibleColumns = columns.filter((col) => !col.hideInExport);

  const headers = visibleColumns.map((col) => col.headerName);
  const data = rows.map((row) => visibleColumns.map((col) => getCellValue(col, row)));

  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(dataBlob, fileName);
};
